module.exports = __webpack_public_path__ + "img/iconBack.11fbb4ae.svg";